"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendButton = SendButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const useDevice_1 = require("../../hooks/useDevice");
const colors_1 = require("../../common/colors");
const AppIcons_1 = require("../AppIcons");
function SendButton({ text, customStyles, disabled, onPress, style, }) {
    const { isWebDevice, isMobileScreen } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: onPress, 
            // underlayColor="white"
            onPressIn: () => {
                // Handle press in event (start of tap)
                console.log("Pressed In");
            }, onPressOut: () => {
                // Handle press out event (end of tap)
                console.log("Pressed Out");
            }, disabled: disabled ? disabled : false, style: [
                style
            ], pointerEvents: "box-none", children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, colors: disabled
                    ? [colors_1.Colors.BLACK_PRIMARY, colors_1.Colors.BLACK_PRIMARY]
                    : colors_1.Colors.GRADIENT, style: [
                    styles.linearGradient,
                    isWebDevice && isMobileScreen && {
                        width: 32,
                        height: 32,
                    },
                    customStyles?.button
                ], children: (0, jsx_runtime_1.jsx)(native_base_1.VStack, { alignItems: "center", justifyContent: "center", flex: 1, children: (0, jsx_runtime_1.jsx)(AppIcons_1.SendIcon, {}) }) }) }) }));
}
const styles = react_native_1.StyleSheet.create({
    linearGradient: {
        display: "flex",
        height: 35,
        width: 35,
        borderRadius: 18,
    },
    linearGradientText: {
        textAlign: "center",
        margin: 0,
        paddingVertical: 12.5,
        fontSize: 16,
        color: "#FFFFFF",
        fontWeight: "bold",
    },
});
